/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  BankAccountTypes,
  BankAccountTypeState
} from '@/store/interfaces/bankAccountType';
import { RootState } from '@/store/interfaces/rootState';
import bankAccountTypeType from '@/store/types/bankAccountType';
import { httpCommpix } from '@/util/HTTPCommpix';
import { AxiosError, AxiosResponse } from 'axios';
import { ActionTree, GetterTree, MutationTree } from 'vuex';

const namespaced = true;

const initialState = (): BankAccountTypeState => {
  return {
    bankAccountTypesList: [],
  };
};

const state: BankAccountTypeState = initialState();

const getters: GetterTree<BankAccountTypeState, RootState> = {
  [bankAccountTypeType.getters.GET_BANK_ACCOUNT_TYPES_LIST]: state => {
    return state.bankAccountTypesList;
  },
};

const mutations: MutationTree<BankAccountTypeState> = {
  reset: (state: any) => {
    const initialStateFields: any = initialState();
    Object.keys(initialStateFields).forEach((key: any) => {
      state[key] = initialStateFields[key];
    });
  },

  [bankAccountTypeType.mutations.SET_BANK_ACCOUNT_TYPES_LIST]: (
    state,
    states: Array<BankAccountTypes>
  ) => {
    const bankAccountTypes: Array<BankAccountTypes> = states;

    state.bankAccountTypesList = bankAccountTypes;
  },
};

const actions: ActionTree<BankAccountTypeState, RootState> = {
  [bankAccountTypeType.actions.BANK_ACCOUNT_TYPES_LIST]: (
    { commit, }
  ) => {
    return new Promise((resolve, reject) => {
      httpCommpix
        .get('/bank-account-types')
        .then((res: AxiosResponse) => {
          commit(
            bankAccountTypeType.mutations.SET_BANK_ACCOUNT_TYPES_LIST,
            res.data
          );
          resolve(res);
        })
        .catch((error: AxiosError) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced,
  state,
  getters,
  mutations,
  actions,
};
